import axios from "axios";
import Apis from "../utils/apis";

const requestInterceptor = (config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.token = `Bearer ${token}`;
  }

  return config;
};

const responseInterceptor = (error) => {
  const status = error?.response?.status;
  const message = error?.response?.data;

  if (
    status === 401 &&
    [
      "SESSION_EXPIRED",
      "ACCOUNT_INACTIVE",
      "ONBOARDING_INCOMPLETE",
      "APPROVAL_PENDING",
      "APPLICATION_REJECTED",
    ].includes(message)
  ) {
    // 🔥 GLOBAL AUTO LOGOUT
    localStorage.clear();
    window.location.reload();
  }

  return Promise.reject(error);
};

const API_AXIOS = axios.create({
  baseURL: Apis.baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

const API_AXIOS_MULTIPART = axios.create({
  baseURL: Apis.baseUrl,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

API_AXIOS.interceptors.request.use(requestInterceptor);
API_AXIOS.interceptors.response.use((res) => res, responseInterceptor);
API_AXIOS_MULTIPART.interceptors.request.use(requestInterceptor);

export { API_AXIOS, API_AXIOS_MULTIPART };
